<template>
  <div>
    <v-card outlined>
      <v-toolbar dense dark color="primary">
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Perfil de jugador</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items> </v-toolbar-items>
      </v-toolbar>
      <v-card-title class="text-h5">
        <h4>Información del jugador</h4>
      </v-card-title>
      <v-card-text v-if="cliente">
        <h5>{{ cliente.Nombres }} {{ cliente.Apellidos }}</h5>
        <v-tabs v-model="tab">
          <v-tab>Perfil</v-tab>
          <v-tab>Reservas</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-simple-table>
                  <thead>
                    <tr>
                      <th>
                        Info
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Alias
                      </td>
                      <td>
                        {{ cliente.Apodo }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Fecha de nacimiento
                      </td>
                      <td>
                        {{ cliente.FechaNacimiento }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Sexo
                      </td>
                      <td>
                        {{ cliente.Sexo }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        HDCP
                      </td>
                      <td>
                        {{ cliente.hdcp }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Ghin
                      </td>
                      <td>
                        {{ cliente.ghin }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Grupo
                      </td>
                      <td>
                        {{ cliente.tipo }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Correo
                      </td>
                      <td>
                        {{ cliente.Correo }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-simple-table>
                  <thead>
                    <tr>
                      <th>
                        Folio
                      </th>
                      <th>Fecha</th>
                      <th>Tee Time</th>
                      <th>Tarifario</th>
                      <th>Categoria</th>
                      <th>Modalidad</th>
                      <th>Precio</th>
                      <th>Estatus</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(res, indx) in reservations" :key="indx">
                      <td>
                        {{ res.Folio }}
                      </td>
                      <td>
                        {{ res.date_format }}
                      </td>
                      <td>
                        {{ res.time_format }}
                      </td>
                      <td>
                        {{ res.Tarifa }}
                      </td>
                      <td>
                        {{ res.Subcategoria }}
                      </td>
                      <td>
                        {{ res.Modalidad }}
                      </td>
                      <td>
                        {{ res.Total }}
                      </td>
                      <td>
                        <b class="red--text" v-if="res.Estatus == 'C'">Cancelado</b>
                        <b class="blue--text" v-if="res.Estatus == 'R'">Reservado</b>
                        <b class="green--text" v-if="res.Estatus == 'P'">Pagado</b>
                        <b  v-if="res.Estatus == 'N'">No Show</b>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-btn @click="getReservations(player.Id,true)" x-small color="secondary" block  outlined dark>
                  Ver más
                </v-btn>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import axiosCore from "axios";
import { mapGetters } from "vuex";
import Cliente from "../../clases/Cliente.js";
import TarifasClass from "../../clases/Tarifa.js";
export default {
  name: "PlayerHistoriCard",
  components: {},
  props: ["player"],
  data() {
    return {
      tab: 0,
      reservas: [],
      tiposJuego: [],
      tarifarios: [],
      lastRecord: null
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async getReservations(id,nextPage) {
      let filters  = [
      this.$store.getters.getFirebaseApp.firestore.where(
            "_IDX",
            "array-contains",
            "C#.I=" + id
          ),
          this.$store.getters.getFirebaseApp.firestore.orderBy(
            "RF.FI",
            "desc"
          ),
          this.$store.getters.getFirebaseApp.firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
          this.$store.getters.getFirebaseApp.firestore.limit(10),
      ];
      if(nextPage){
        filters.push(this.$store.getters.getFirebaseApp.firestore.startAfter(this.lastRecord));
      }
      const data = await this.$store.getters.getFirebaseApp.firestore.queryBuilder(
        "RVA_Reservas",
        filters
      );

      let listEvents = data.docs.map((doc) => {
        this.lastRecord = doc
        return { id: doc.ref.id, ...doc.data() };
      });

      if(nextPage){
        this.reservas = this.reservas.concat(listEvents);
      }else{
        this.reservas = listEvents;
      }

      //this.reservas = listEvents;
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/Golf/Modalidades"
      );
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
      });

    },
    async getComboTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
    },
  },
  computed: {
    data_clientes() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          clientes.push(element);
        }
      });

      return clientes;
    },
    reservations() {
      let reservas = [];
      this.reservas.forEach((res) => {
        let cuentas = Object.entries(res.Cuentas);
        cuentas.forEach((cuenta) => {
          if (cuenta[1].IdCliente) {
            if (cuenta[1].IdCliente == this.cliente.Id) {
              let tarifaData = cuenta[1].Catalogo[0]?.ExtraParams?.TarifaData
              let esCupon = tarifaData?.EC
              let tipoJuego = this.$pgsHelper.getById(
                this.tiposJuego,
                "id",
                tarifaData.Mod
              );
              let tarifa = this.$pgsHelper.getById(
                this.tarifarios,
                "Id",
                tarifaData.Tar
              );
              let format_date = moment(res.RF.FI, "YYYY-MM-DD_HH:mm:ss");
              reservas.push({
                date_format: format_date.format("DD-MM-YYYY"),
                time_format: format_date.format("HH:mm"),
                Folio: res.Folio,
                Player: this.cliente.Nombres + " " + this.cliente.Apellidos,
                Fecha: res.RF.FI,
                Plys: (cuentas.length - 1),
                Total: cuenta[1].Catalogo[0].Pco + " " + cuenta[1].Catalogo[0].Mnd,
                Estatus: (res.Estatus == "Cancelled") ? "C" : (cuenta[1].Estatus),
                Tarifa: tarifa.text,
                Subcategoria: tarifaData.SubN,
                Modalidad: tipoJuego.nombre,

              });
            }
          }
        });
      });
      return reservas;
    },
    cliente() {
      if (this.player.Id) {
        let cliente = this.$pgsHelper.getById(
          this.data_clientes,
          "Id",
          this.player.Id
        );
        return cliente;
      }
      return null;
    },
  },
  watch: {},
  beforeMount: function () { },
  mounted() {
    if (this.player.Id) {
      this.getReservations(this.player.Id);
      this.getTiposJuego();
      this.getComboTarifarios();
    }
  },
};
</script>
